/* Entrance animations for blog article blocks (WEB-6276).
 *
 * Legacy rows carry data-custom-animations (GSAP fade + slide on scroll); the
 * import stores each row's starting offset and the renderer emits it as
 * [data-sh-anim] + --sh-anim-x/y. This observer adds .sh-in when a block
 * enters the viewport.
 *
 * Fail-open by design: the hidden initial state is gated on html.sh-anim-ready,
 * stamped HERE — if this file never runs, no content is ever hidden. Reduced
 * motion is handled in CSS.
 */
(() => {
  if (document.documentElement.classList.contains('sh-anim-ready')) return;
  // Every piece of article media reveals on scroll (Ruben 2026-08-12) — not
  // only the widgets live marks with data-inview. Stamped here rather than in
  // Liquid so inline rte figures are covered without a re-import, and so the
  // no-JS page never carries the attribute at all.
  document
    .querySelectorAll(
      '.sexyhair-article-block__rte figure, .sexyhair-article-block__media, .sexyhair-article-block__two-col-media, .sexyhair-article-gallery__item, .sexyhair-article-columns__col'
    )
    .forEach((el) => {
      if (!el.hasAttribute('data-sh-anim')) el.setAttribute('data-sh-anim', '');
    });
  const blocks = document.querySelectorAll('[data-sh-anim]');
  const fades = document.querySelectorAll('[data-sh-fade]');
  if ((!blocks.length && !fades.length) || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('sh-anim-ready');
  // On-LOAD fades (the blog banner, article h1s): hidden state applies with
  // sh-anim-ready above; revealing on the second frame lets the transition
  // actually play. Same fail-open contract as the scroll reveals.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      fades.forEach((el) => el.classList.add('sh-in'));
    });
  });
  if (!blocks.length) return;
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('sh-in');
        io.unobserve(entry.target);
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  blocks.forEach((el) => {
    // Anything already in the viewport at load renders in place — animating
    // above-the-fold content on arrival reads as a flash, and live only
    // animates rows you scroll to.
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('sh-in');
    io.observe(el);
  });
})();
